import { useLocation, useNavigate } from 'react-router-dom';
import { AES, enc } from "crypto-js";
import Timer from './Timer';
import { usersApiSlice } from '../../store/auth/usersApiSlice';
import { useDispatch, useSelector } from 'react-redux';
import { clearUserInfo, hideModal } from '../../store/auth/authSlice';
import { SessionExpired } from './SessionExpired';
import { Modal } from './Modal';

const { REACT_APP_VERIFICATION_CODE, REACT_APP_PUBLIC_ACCESS_TOKEN, REACT_APP_ENVIRONMENT } = process.env;

const PrivateRoute = ({ children, token = true }) => {
  const location = useLocation();
  const isPrompt = location.pathname.includes("prompt")
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const isModalVisible = useSelector((state) => state.auth.isModalVisible);

  const handleCloseModal = () => {
    dispatch(clearUserInfo());
    dispatch(hideModal());
    navigate(isPrompt ? "/login/prompt" : "/login");
  };

  const userToken = localStorage.getItem('jwt');
  const otp = localStorage.getItem('appvalue');
  const bytes = AES?.decrypt(otp ?? "", REACT_APP_PUBLIC_ACCESS_TOKEN);
  const originalText = bytes?.toString(enc.Utf8);

  return (((REACT_APP_ENVIRONMENT === 'testing' || REACT_APP_ENVIRONMENT === 'development') && originalText === REACT_APP_VERIFICATION_CODE) || REACT_APP_ENVIRONMENT === 'production') ? (
    <>
      {token ? userToken ? <><Timer /> {children}</> : navigate(isPrompt ? "/login/prompt" : "/login") : <><Timer /> {children}</>}
      {isModalVisible && (
        <Modal modalHandle={handleCloseModal}>
          <SessionExpired
            message="Duplicate Login Detected"
            subMessage="We noticed your account is active elsewhere. Please sign in again."
          />
        </Modal>
      )}
    </>
  ) : navigate("/verification")
};

export default PrivateRoute;